import styled from "styled-components";

const PayoffsTable = styled.table`
  width: 100%;
`;

export default PayoffsTable;
